// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMemo, useState } from 'react';
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import TemplateContract from '../../../../../utils/TemplateContract';
import { useMarketData } from '../../../common/marketData/useMarketData';

export const useCallInitialMarginForm = (
  collateralAgreement?: TemplateContract<CollateralAgreement>,
) => {
  // --- REFERENCE ---
  const [reference, setReference] = useState<string>('');

  // --- REQUIRED VALUE ---
  const [requiredValue, setRequiredValue] = useState<string>('');

  // --- MARKET DATA ---
  const { marketData, addPricingData, updatePricingData, removePricingData } =
    useMarketData(collateralAgreement);

  // --- UTILS ---
  const isSubmitDisabled = useMemo(() => {
    const isMarketDataValid =
      marketData.length > 0 &&
      marketData.every((pricingData) => {
        return (
          pricingData.instrument &&
          pricingData.tag &&
          pricingData.value &&
          parseFloat(pricingData.value) > 0
        );
      });

    const isFormValid = requiredValue && parseFloat(requiredValue) > 0 && isMarketDataValid;

    return !isFormValid;
  }, [requiredValue, marketData]);

  return {
    reference,
    setReference,

    requiredValue,
    setRequiredValue,

    marketData,
    addPricingData,
    updatePricingData,
    removePricingData,

    isSubmitDisabled,
  };
};
